var PubSub = require('libs/pub-sub');
var PubSubMessageKeys = require('utils/pubSubMessageKeys');

module.exports = {

  /**
    * This function is used to handle success call back for ajax hits on Modal form submit
    * @param {Object} Response returned on successful ajax hit
    * @param {DOM Element} Reference to dom element of component which triggered ajax request
    * @param {Callback} Callback function if any additional functionality to be executed.
    */
  success : function(data,self,callback){
    var componentToRefresh = data.messageIdentifier;
    if(data.status === 'success' || (data.status === 'failure' && self.isProfileSavedCardDetails)){
      PubSub.publishGlobal(PubSubMessageKeys['POPUP_CLOSE']);
      window.scrollTo(0,0);
    }else if(!self.$el.data('removeFormDataNode')){
      var context = {
        pageURI: ""
      };
      self.refresh(self.updatePageURI ? context : undefined);
    }else {
      var context = {
        formData: ""
      };
      self.refresh(context);
    }
    PubSub.publishGlobal(PubSubMessageKeys['REFRESH_MESSAGE_BOX'],[componentToRefresh, self.updatePageURI]);
    PubSub.publishGlobal(PubSubMessageKeys['REFRESH_NEW_ENROLLMENT_HIGHLIGHTS']);
    if(typeof callback === 'function'){
      callback.call(self,data);
    }
  },

  /**
    * This function is used to handle error call back for ajax hits on Modal form submit
    * @param {Object} Error returned on unsuccessful ajax hit
    * @param {Callback} Callback function if any additional functionality to be executed.
    * @param {DOM Element} Reference to dom element of component which triggered ajax request
    */
  error : function(errorMsg,self,callback){
    if(typeof callback === "function"){
      callback.call(self,errorMsg);
    }
  }
}
